// وضعیتِ نمایشیِ یک خودرو برای ردیفِ لیست.
// از همان داده‌های زنده (onlineStatus / serverStatus / serverInfo / expire) یک مدلِ ساده می‌سازد:
// رنگِ ردیف، آیکونِ آواتار، و سه نشانگرِ ارتباط/حرکت/موقعیت با متنِ فارسیِ ساده.
// در MapDesktop (کامپیوتر) و Map (موبایل) مشترک استفاده می‌شود تا منطق در یک جا بماند.

const GREEN = '#28c76f'
const AMBER = '#ff9f43'
const RED = '#ea5455'
const GRAY = '#a8b1bd'

const LOC_LIVE = { icon: 'mdi-crosshairs-gps', label: 'موقعیت زنده', cls: 'ddt-green' }
const LOC_LASTPARK = { icon: 'mdi-map-marker', label: 'آخرین محلِ پارک', cls: 'ddt-amber' }
const LOC_LAST = { icon: 'mdi-map-marker', label: 'آخرین محل', cls: 'ddt-gray' }

// پنجرهٔ «آنلاین»: اگر دستگاه در این مدت status یا position فرستاده باشد، آنلاین است.
// GT06 حتی هنگام پارک هر چند دقیقه یک‌بار status می‌فرستد، پس ۱۵ دقیقه حاشیهٔ امنی دارد.
const ONLINE_WINDOW = 15 * 60

export function deviceDisplay (item) {
  // وضعیتِ آنلاین از تازگیِ واقعیِ آخرین تماس محاسبه می‌شود، نه از اسنپ‌شاتِ onlineStatus
  // (که در بعضی نشست‌ها کهنه می‌ماند و خودروی آنلاین را آفلاین نشان می‌دهد).
  const nowSec = Math.floor(Date.now() / 1000)
  const statusTime = (item && item.serverStatus && item.serverStatus.servertime) || 0
  const positionTime = (item && item.serverInfo && item.serverInfo.servertime) || 0
  const lastContact = Math.max(statusTime, positionTime)
  const online = lastContact > 0 && (nowSec - lastContact) < ONLINE_WINDOW
  const terminal = (item && item.serverStatus && item.serverStatus.terminalInfo) || {}
  const speed = (item && item.serverInfo && item.serverInfo.speed) || 0
  const gps = !!terminal.gpsTracking
  const ignition = !!terminal.ignition
  const expired = !!(item && item.expire)

  if (expired) {
    return { kind: 'exp', color: RED, avatarIcon: 'mdi-car-off', online: false, expired: true }
  }

  if (!online) {
    return {
      kind: 'off', color: GRAY, avatarIcon: 'mdi-car', online: false, expired: false,
      move: { icon: 'mdi-timer-sand', label: 'آفلاین' },
      loc: LOC_LAST,
    }
  }

  const moving = speed > 2 && gps

  // حرکت بدون روشن بودنِ موتور (یدک‌کش/هشدار سرقت)
  if (moving && !ignition) {
    return {
      kind: 'tow', color: RED, avatarIcon: 'mdi-alert', online: true, expired: false,
      move: { icon: 'mdi-tow-truck', label: 'حرکت بدون روشن بودن!' },
      loc: LOC_LIVE,
    }
  }

  if (moving) {
    return {
      kind: 'move', color: GREEN, avatarIcon: 'mdi-car', online: true, expired: false,
      move: { icon: 'mdi-navigation', label: `در حال حرکت${speed ? ` · ${speed} km/h` : ''}` },
      loc: LOC_LIVE,
    }
  }

  if (ignition) {
    return {
      kind: 'idle', color: GREEN, avatarIcon: 'mdi-car', online: true, expired: false,
      move: { icon: 'mdi-engine', label: 'موتور روشن، متوقف' },
      loc: gps ? LOC_LIVE : LOC_LAST,
    }
  }

  // پارک: موتور خاموش و متوقف
  return {
    kind: 'park', color: AMBER, avatarIcon: 'mdi-car', online: true, expired: false,
    move: { icon: 'mdi-car-brake-parking', label: 'پارک (موتور خاموش)' },
    loc: gps ? LOC_LIVE : LOC_LASTPARK,
  }
}

export default deviceDisplay
